import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { LeadReminder } from "./schema";
import { useTakeActionModal } from "../disable-reminder-action/use-action-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as LeadReminder;

  const { onOpenChange, setLead } = useTakeActionModal();

  return (
    <div className="flex items-center gap-3">
      <Button
        size="sm"
        variant="outline"
        onClick={() => {
          setLead({
            id: originData?.id,
          });
          onOpenChange(true);
        }}
        disabled={originData?.disabled}
      >
        {originData?.disabled ? "Disabled" : "Disable Reminder"}
      </Button>
    </div>
  );
}
